import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/cloud-mig/comprehensive_cloud.webp";
import {
  CloudMigCloudApp,
  CloudMigDataware,
  CloudMigSec,
  CloudMigOpt,
} from "../../../app-constants";

function Comprehensivecloud() {
  return (
    <section
      className="comprehensive_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>Comprehensive Cloud Migration Services</h2>
            <h5>Performant. Secure. Expansible.</h5>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="comprehensive_box">
                  <div className="compre_main">
                    <div className="compre_img">{CloudMigCloudApp}</div>
                    <div className="compre_head">
                      <h5>
                        Cloud Application Migration (Single or Multiple Apps)
                      </h5>
                    </div>
                  </div>
                  <div className="compre_content">
                    <p>
                      Our cloud migration specialists plan, design, and
                      implement custom app migration solutions to the cloud,
                      harnessing the power of cloud services and streamlined
                      CI/CD pipelines. Whether it's a single app or a complex
                      suite, we ensure high performance and cost-effectiveness
                      throughout the cloud migration process.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="comprehensive_box">
                  <div className="compre_main">
                    <div className="compre_img">{CloudMigDataware}</div>
                    <div className="compre_head">
                      <h5>Data Warehouse Migration</h5>
                    </div>
                  </div>
                  <div className="compre_content">
                    <p>
                      Transform your data warehouse for the cloud era. We employ
                      next-gen cloud services and serverless ETL models for
                      fail-safe, future-proof migration. We not only help you
                      reduce cloud consumption costs but also optimizes data
                      warehouse performance, unlocking insights and efficiencies
                      for your business.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="comprehensive_box">
                  <div className="compre_main">
                    <div className="compre_img">{CloudMigSec}</div>
                    <div className="compre_head">
                      <h5>Security & Compliance Management</h5>
                    </div>
                  </div>
                  <div className="compre_content">
                    <p>
                      Our expert cloud migration consultants implement
                      zero-trust security protocols in your cloud environment
                      for full compliance with industry standards and
                      regulations. Through continuous monitoring and threat
                      detection, we maintain robust security, keeping your cloud
                      eco-system safe and performing against all cyber threats.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                <div className="comprehensive_box">
                  <div className="compre_main">
                    <div className="compre_img">{CloudMigOpt}</div>
                    <div className="compre_head">
                      <h5>Optimization & Support</h5>
                    </div>
                  </div>
                  <div className="compre_content">
                    <p>
                      We prioritize resource optimization and costs minimization
                      while maximizing performance in your cloud infrastructure.
                      Our expertise extends to seamless integration of
                      multi-cloud and hybrid solutions, backed by ongoing
                      support, maintenance, and performance monitoring to keep
                      your cloud environment running at full potential.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
               Migrate to Cloud
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Comprehensivecloud;
